// File upload controller for auto-submitting forms on file selection
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Auto-submit form when file is selected
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener("change", this.handleFileSelect.bind(this))
    }
  }

  disconnect() {
    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener("change", this.handleFileSelect.bind(this))
    }
  }

  handleFileSelect(event) {
    if (event.target.files.length > 0) {
      // Submit the form
      this.element.closest("form")?.submit()
    }
  }
}

